import { NavLink } from 'react-router-dom';
import { useTheme } from './ThemeContext';

function Layout({ children, nav }) {
  const { dark, toggle } = useTheme();

  return (
    <div className="site">
      <div className="site-inner">
        <div className="site-top">
          <nav className="sidebar">
            {nav || (
              <>
                <NavLink
                  to="/writings"
                  className={({ isActive }) => `sidebar-link ${isActive ? 'sidebar-link--active' : ''}`}
                >
                  Writing
                </NavLink>
                <NavLink
                  to="/"
                  end
                  className={({ isActive }) => `sidebar-link ${isActive ? 'sidebar-link--active' : ''}`}
                >
                  About
                </NavLink>
              </>
            )}
          </nav>
          <label className="theme-toggle">
            <span className="theme-toggle-label">Light</span>
            <input
              type="checkbox"
              checked={dark}
              onChange={toggle}
            />
            <span className="theme-toggle-track" />
            <span className="theme-toggle-label">Dark</span>
          </label>
        </div>
        <main className="main">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
